module.exports = __webpack_public_path__ + "static/media/1.dfed7d47.jpg";